import m1 from './../assets/Images/masters/m1.png'; 
import m3 from './../assets/Images/masters/m3.png';
import m4 from './../assets/Images/masters/m4.png';

import e1 from './../assets/Images/events/P1E1B1.png';   
import e4 from './../assets/Images/events/P1E4B1.jpeg';  
 

import P3E1B1 from './../assets/Images/events/P3E1B1.jpeg';  
import P3E2B1 from './../assets/Images/events/P3E2B1.jpg';  
import P3E3B1 from './../assets/Images/events/P3E3B1.jpeg';   
 
import P4E3B1 from './../assets/Images/events/P4E3B1.jpeg';    

 
 
import P3 from './../assets/Images/programs/p3.png'
import P4 from './../assets/Images/programs/p4.png'

export interface Event {
  id: string;
  name: string;
  eventType:string;
  description: string;
  shortDescription: string;
  priceDescription: string;
  isSoldOut?: boolean;
  date: string;
  dateOfEvent: string;
  time: string;
  location: string; 
  locationLink: string;
  priceOfEvent: string;
  priceOfEventRu?: string;
  priceOfEventOnline?: string;
  priceOfEventRuOnline?: string;
  stripeLink: string; 
  kassaLink?: string; 
  stripeLinkOnline?: string; 
  image:string;
  image2?:string;
  image3?:string;
  eventMaster:string;
  videoLink? : string;
  listOfBenefits: string[]
  keyTakeaways: { title: string; description: string }[]; // Key takeaways
}

export interface Program {
  id: string;
  title: string;
  image: string;
  programMasterImage: string;
  dateRange: string;
  startDate: string;
  category: string;
  price: string;
  masterId: string;
  Masters: string;  
  videoLink? : string;
  description: string; 
  stripeLink: string;
  noOfEvents: number;
  events: Event[];
  whatsIncluded: string[];
}

const Programs: Program[] = [
  {
    id: 'program1',
    title: ' Fatal Endings: Secrets of Russian Geniuses',
    image: e1,
    programMasterImage:m1,
    dateRange: ' 20th March - 17th April',
    startDate: '2025-03-20',
    category: 'Literature',
    price: '1,800 AED',
   
    masterId: 'm1',
    Masters: 'Vladislav Otroshenko', // References Master by ID
    whatsIncluded: [
      'Offline lecture',
      'Q&A with master',
     
      'Soft drinks'
    ],
    description:
      'Dark mysteries surround the final days of Russia`s literary giants. Through meticulous historical research and archival documents, this program investigates the tragic destinies of four remarkable authors: Pushkin`s fatal duel, Gogol`s burning of his masterpiece and mysterious death, Sukhovo-Kobylin`s scandalous murder case, and Tolstoy`s prophetic last work and death. Vladislav Otroshenko will uncover the dramatic circumstances that led to these fateful endings, examining how art, destiny, and tragedy intertwined in Russian literary history.',
     
    stripeLink: 'https://buy.stripe.com/fZe15Qecv9GNgrm9AK',
    events: [   
      {
        id: 'event5',
        eventMaster:'Vladislav Otroshenko',
        name: '“Hadji Murat” - Tolstoys Last Battle with Destiny',
        shortDescription: 'Enter the passionate world of Tolstoy`s final masterpiece, where his art and faith clash in a battle that shaped his last days. See how "Hadji Murat" reflects its creator`s own dramatic journey, as we explore the hidden forces that led Russia`s greatest writer toward his final escape.',
        description: 'The artist and philosophical thinker—two essences of Leo Tolstoy came into irreconcilable conflict toward the end of his life`s journey. The novella "Hadji Murat" was born in the fierce struggle between these Tolstoyan principles. And within it was foreshadowed the canvas of dramatic events that would lead its author, like the story`s central figure, to perish in the initial stages of his escape... The mystical, literary, and fateful aspects of Tolstoy`s final artistic creation—these will be the focus of Vladislav Otroshenko`s lecture.',
         date: '17th April ',
         dateOfEvent: '2025-04-17',
        time: '19:00 ',
        location: 'Etihad Museum', 
        eventType:'In Person',
        locationLink: 'https://maps.app.goo.gl/q82UqkmJch2WNr4y9',
        priceOfEvent: '400 AED',
        priceOfEventRu :'9,000 RUB',
        priceDescription: 'Enter the passionate world of Tolstoy`s final masterpiece, where his art and faith clash in a battle that shaped his last days. See how "Hadji Murat" reflects its creator`s own dramatic journey, as we explore the hidden forces that led Russia`s greatest writer toward his final escape.',
        stripeLink: 'https://buy.stripe.com/28oeWGecv1ahgrmaFk',
        kassaLink: 'https://buy.stripe.com/7sI8yi4BV5qxb729B4',
        image:e4,
        listOfBenefits: [
          'Offline lecture',
          'Q&A with master',
         
          'Soft drinks'
        ],
        keyTakeaways: [
           {
            title: 'New Perspectives on Tolstoy’s Legacy',
            description: 'Gain fresh insight into how his final work redefined his literary and ideological journey.'
          },
          {
            title: 'Exploration of the Mystical and Philosophical Themes',
            description: 'Unravel the deeper, almost prophetic dimensions of Tolstoy’s last literary masterpiece.'
          },
          {
            title: 'Reflection on Fate and Free Will',
            description: 'Examine the philosophical questions Tolstoy grappled with and how they shaped both his fiction and his real-life decisions.'
          },
          {
            title: 'Understanding the Connection Between Art and Life',
            description: 'See how Tolstoy’s personal struggles played out in his literature, blurring the lines between fiction and reality.'
          }
        ]
      },
    ],
    noOfEvents: 0, // Placeholder
  }, 
  {
    id: 'program3',
    title: 'Power, Secrets, and Legacy: Hidden Histories',
    image: P3,
    programMasterImage:m3,
    dateRange: '3rd April - 14th May',
    startDate: '2025-04-03',
    category: 'History',
    price: '1,000 AED',
    masterId: 'm3',
    whatsIncluded: [
      'Offline lecture',
      'Q&A with master',
     
      'Soft drinks'
    ],
    Masters: 'Denis Kobba', // References Master by ID
    description:
      ' Hidden forces of power shape history’s greatest stories. This program unravels three fascinating aspects of historical influence: the mysterious world of Freemasonry and secret societies, the dark side of fame through assassination attempts on public figures, and the rise and fall of the Roman Empire. Even though these events occurred in different time periods and may not seem connected at first glance, they are all driven by power, ambition, and the relentless pursuit of control. Denis Kobba explores how these forces continue to influence societies, revealing patterns of authority, secrecy, and manipulation that transcend time.',
    
    stripeLink: 'https://buy.stripe.com/eVa4i2d8rdX3cb68wE',
    
    events: [
    
      {
        id: 'P3E2B1',
        eventMaster:'Denis Kobba',
        name: 'Assassinations: The Dangers of Fame  ',
        shortDescription: 'Uncover the dark side of fame by examining assassination attempts on public figures throughout history, from the shocking murder of JFK',
        description:'What price do the famous pay for their influence? Throughout history, public figures have walked a fine line between power and danger, with some paying the ultimate cost. This lecture explores the chilling reality of assassination attempts, from the shocking murder of JFK to the evolving threats faced by world leaders today. Beyond the headlines, it delves into the hidden costs of fame, the psychology of those who seek to silence influential voices, and the security measures designed to prevent such tragedies. Denis Kobba brings his expertise to unravel the complex relationship between notoriety and personal safety, offering a gripping analysis of history’s most infamous attacks and the modern challenges of protecting those in the public eye.',
          date: '24th April ',
        dateOfEvent: '2025-04-24',
        time: '19:00 ',
        location: 'Etihad Museum', 
        eventType:'Digital',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB', 
        priceDescription: 'Uncover the dark side of fame by examining assassination attempts on public figures throughout history, from the shocking murder of JFK to modern security challenges. ',
        stripeLink: 'https://buy.stripe.com/cN2g0KgkD8CJdfa9Bs', 
        kassaLink: 'https://yookassa.ru/my/i/aAE-k1F-qcBS/l',
        image:P3E2B1,
        listOfBenefits: [
          'Offline lecture',
          'Q&A with master',
         
          'Soft drinks'
        ],
        keyTakeaways: [
          {
            title: 'See the Connection Between Power, Influence, and Risk',
            description: 'Learn how fame can make individuals vulnerable and the strategies used to mitigate those dangers.'
          },
          {
            title: 'Understand the Psychology Behind Assassinations',
            description: 'Learn about the mindset of those who attempt to silence influential figures and the broader social and political implications.'
          },
          {
            title: 'Develop a Critical Perspective on Historical Events',
            description: 'Separate fact from speculation in infamous cases, gaining a deeper and more informed understanding of their impact on society.'
          },
          {
            title: 'Apply Lessons to Contemporary Issues',
            description: 'Use insights from historical assassinations to better understand modern security threats, political instability, and the risks faced by today’s global leaders.'
          }
        
        ]
      }, 
     
      {
        id: 'P3E3B1',
        eventMaster:'Denis Kobba',
        name: 'Rome: From Dawn to Dusk',
        description: 'The rise and fall of Rome is one of history’s greatest stories—an empire that shaped the world, only to crumble under its own weight. From a small settlement on the Tiber to the most powerful civilization of its time, Rome’s ascent was driven by military conquest, political ambition, and groundbreaking innovations. But what forces led to its decline? Was it inevitable, or could history have taken a different turn? This lecture explores the key moments that defined Rome’s journey, from its legendary founding by Romulus to its final days under Romulus Augustulus. Drawing on his expertise in historical power structures, Denis Kobba unpacks the political struggles, societal shifts, and external pressures that sealed Rome’s fate. Through this exploration, discover how the lessons of Rome’s triumphs and failures continue to echo in modern civilizations.',
       shortDescription: 'Unravel the dramatic rise and fall of Rome, from a humble settlement to history`s mightiest empire. Discover how power, ambition, and fate shaped the eternal city`s destiny.',
        date: '14th May',
       dateOfEvent: '2025-05-14',
        time: '19:00 ',
        location: 'Zoom', 
        eventType:'Digital',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB',
        priceDescription: 'Unravel the dramatic rise and fall of Rome, from a humble settlement to history`s mightiest empire. Discover how power, ambition, and fate shaped the eternal city`s destiny.',
        stripeLink: 'https://buy.stripe.com/00g7ueb0jaKRcb68xk',
        kassaLink: 'https://yookassa.ru/my/i/aAE-LJq9vY2x/l',
        image:P3E3B1,
        listOfBenefits: [
          'Offline lecture',
          'Q&A with master', 
          'Soft drinks'
        ],
        keyTakeaways: [
          {
            title: 'Analyze the Causes of Imperial Decline',
            description: 'Examine whether Rome’s fall was inevitable or the result of avoidable decisions, drawing lessons that apply to modern civilizations.'
          },
          {
            title: 'Engage with Fascinating Historical Narratives',
            description: 'Experience the drama of Rome’s history, from its legendary founding to its final days, through compelling storytelling and expert commentary.'
          },
          {
            title: 'Uncover the Political and Military Strategies of Rome',
            description: 'Learn how leadership, warfare, and governance played a role in both the empire’s expansion and its eventual collapse.'
          },
          {
            title: 'Draw Parallels Between Past and Present',
            description: 'Recognize the warning signs of decline in powerful nations and how the lessons of Rome remain relevant in today’s global landscape.'
          }
        ]
      },  
      {
        id: 'P3E1B1',
        eventMaster:'Denis Kobba',
        name: 'Freemasons: Conspiracy without Conspiracy Theories',
        shortDescription: 'Explore influence and relevance of secret societies  in the 21st century. By uncovering history, symbolism, and influence of the Freemasons, separating fact from fiction to uncover their true role in shaping society.',
        description:
          'Embak on an investigative journey into the enigmatic world of secret societies, with a particular focus on the Freemasons—one of the most influential and controversial organizations in history. Explore their origins, tracing their evolution from medieval stonemason guilds to modern fraternal networks, and examine their role in shaping political, cultural, and intellectual movements.   Drawing from Denis Kobba’s unique position as both an academic historian and FSB Academy lecturer, we will analyze historical evidence to separate myth from reality, uncovering the rituals, symbols, and philosophies that define the Freemasons. Assess their influence and relevance in the 21st century, questioning whether these secretive traditions still hold power in today`s world.',
        date: '28th May',
        dateOfEvent: '2025-05-28',
        time: '19:00 ',
        location: 'Zoom', 
        eventType:'Digital',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB',
        priceDescription: 'Explore influence and relevance of secret societies  in the 21st century. By uncovering history, symbolism, and influence of the Freemasons, separating fact from fiction to uncover their true role in shaping society.',
        stripeLink: 'https://buy.stripe.com/9AQbKu8SbbOVfnibJD',
        kassaLink: 'https://yookassa.ru/my/i/aAE-dlFPvQFN/l',
        image:P3E1B1,
        listOfBenefits: [
          'Offline lecture',
          'Q&A with master',
         
          'Soft drinks'
        ],
        keyTakeaways: [
          {
            title: 'Insight into Political and Cultural Influence',
            description: 'Understand how the Freemasons shaped key historical events, movements, and ideologies.'
          },
          {
            title: 'Decoding Symbols and Rituals',
            description: 'Explore the meaning behind Masonic symbols, traditions, and their significance.'
          },
          {
            title: 'Modern Relevance of Secret Societies',
            description: 'Examine the role of the Freemasons in today’s world and their ongoing cultural impact.'
          },
          {
            title: 'Engaging and Thought-Provoking Exploration',
            description: 'Challenge common perceptions and uncover hidden aspects of a centuries-old tradition.'
          }
        ]
      },
    ],
    noOfEvents: 0, // Placeholder
  },
  {
    id: 'program4',
    title: 'The Russian Identity: Art, Influence, and Cultural Power',
    image: P4,
    programMasterImage:m4,
    dateRange: '4th March - 6th May',
    startDate: '2025-03-04',
    category: 'Culture',
    price: '1,800 AED',
    masterId: 'm4',
    whatsIncluded: [
      'Offline lecture',
      'Q&A with master',
     
      'Soft drinks'
    ],
    Masters: 'Anna Esparsa', // References Master by ID
    description:
      'From literature and leadership to music and cuisine, this course uncovers the cultural forces that shaped Russian identity and continue to inspire the world. Led by renowned scholar Anna Esparsa, you will explore the enduring power of Russian literature, the hidden influence of women in power, and the timeless language of classical music.Through rare archival materials, masterful compositions, and even a unique lecture-tasting experience, discover how art, authority, and storytelling intertwine in Russian history. Engage with Anna Esparsa’s expert analysis as she brings these themes to life, revealing the prof',
     
    stripeLink: 'https://buy.stripe.com/28o4i28Sbf17fni5kk', 
    events: [  
     
     
    ],
    noOfEvents: 0, // Placeholder
  },
];


// Update `noOfEvents` dynamically before exporting
Programs.forEach((program) => {
  program.noOfEvents = program.events.length;
});

export { Programs };
